
import Vue from 'vue'

export default Vue.extend({
  data: () => ({
    section: 'storage'
  }),

  computed: {
    sections(): any {
      return [
        'Storage',
        'Settings',
        'Identity',
        'Node'
      ]
    }
  }
})
